import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import * as _ from 'lodash';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';
import { AttributeUiType } from 'src/app/shared/models/attributes/attributeUiType';
import { AttributeEditorMode } from 'src/app/shared/models/attributes/attributeEditorMode';
import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';
import { AttributesEditorDataSource } from 'src/app/shared/components/attributes-editor/attributesEditorDataSource';
import { CustomFieldEditorService } from 'src/app/shared/services/custom-field-editor.service';

@Component({
  selector: 'app-custom-field-editor-modal',
  templateUrl: './custom-field-editor-modal.component.html',
  styleUrls: ['./custom-field-editor-modal.component.scss'],
})
export class CustomFieldEditorModalComponent {
  private customFieldValues: Attribute[];
  private customField: AttributeDefinition;
  public personId: string = '';
  public editorDataSource = new AttributesEditorDataSource();

  constructor(
    private customFieldEditorService: CustomFieldEditorService,
    public dialogRef: MatDialogRef<CustomFieldEditorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.personId = data.personId;
    this.customField = data.customField;
    this.customFieldValues = data.customFieldValues;

    let cloned = _.cloneDeep(this.customFieldValues);
    this.editorDataSource.load(cloned, [this.customField], this.filterAttribute());
  }

  get firstElementValueListItem(): AttributeDefinitionValueListItem {
    return this.customFieldValues[0]?.attributeDefinitionValueListItem;
  }

  get personDetailsMode(): AttributeEditorMode {
    return AttributeEditorMode.PersonDetails;
  }

  private filterAttribute() {
    let comp = this;
    return (attributes: Attribute[]) =>
      attributes.filter((a) => a.attributeDefinitionId == comp.customField.id);
  }

  private updateDocuments(attribute: AttributeWrite) {
    if (attribute && attribute.hasValue()) {
      this.customFieldEditorService.update.next({
        attributeWriter: attribute,
        isComplexField: false,
        complexAttributeWriters: null,
      });
    } else {
      this.customFieldEditorService.clear.next(this.customField.id);
    }
  }

  public formIsValid(): boolean {
    return this.editorDataSource.profileisValid;
  }

  public isDocument(): boolean {
    return this.customField.uiType == AttributeUiType.Document;
  }
  public isComplexFiled(): boolean {
    return this.customField.uiType == AttributeUiType.Complex;
  }

  public doSave() {
    if (this.formIsValid()) {
      if (this.isComplexFiled()) {
        let attrs = this.editorDataSource.asComplexAttributeWrites()[0];
        if (attrs.length > 0) {
          this.customFieldEditorService.update.next({
            attributeWriter: null,
            isComplexField: true,
            complexAttributeWriters: attrs,
          });
        } else {
          this.customFieldEditorService.clear.next(this.customField.id);
        }
      } else {
        let attr = AttributeWrite.fromAttributes(this.editorDataSource.editable);
        if (attr) {
          this.customFieldEditorService.update.next({
            attributeWriter: attr,
            isComplexField: false,
            complexAttributeWriters: null,
          });
        } else {
          this.customFieldEditorService.clear.next(this.customField.id);
        }
      }
      this.dialogRef.close();
    }
    return;
  }

  public onClose() {
    this.dialogRef.close();
  }

  public doSaveDocument(attributeChanged = true) {
    if (attributeChanged == false) {
      return;
    }

    if (this.isDocument()) {
      let attribute = AttributeWrite.fromAttributes(this.editorDataSource.editable);
      this.updateDocuments(attribute);
    }
  }
}
